import { gql } from '@apollo/client';

export const DUPLICATE_ACTIVITY = gql`
  mutation duplicateActivity($id: ID!) {
    input: duplicateActivity(id: $id) {
      id
      name
    }
  }
`;
